/**
 * Where to send someone right after they sign in.
 *
 * Signing in lands on the dashboard. A `next` deep link is honoured when it
 * points at a specific task (an idea, a memo, checkout, settings), but hub and
 * overview pages are not "tasks": being bounced to sign-in from one of them
 * shouldn't make it the landing page, so those go to the dashboard instead.
 */
const HUB_PATHS = new Set(['/', '/strategy', '/intelligence', '/ideas', '/dashboard', '/signin', '/signup']);

export function postSignInPath(next: string | null | undefined): string {
  if (!next) return '/dashboard';
  let target = next;
  try {
    target = decodeURIComponent(next);
  } catch {
    /* keep as-is */
  }
  // Only same-site paths; anything else falls back to the dashboard.
  if (!target.startsWith('/') || target.startsWith('//')) return '/dashboard';
  const path = target.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return HUB_PATHS.has(path) ? '/dashboard' : target;
}
